(function () {
  function getSectionHeight(section) {
    if (!section) return 0;
    var style = window.getComputedStyle(section);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    return section.getBoundingClientRect().height;
  }

  function updateStickyOffset() {
    var offset = 0;
    var headerSection = document.querySelector('.shopify-section__header');

    if (headerSection) {
      var node = headerSection.previousElementSibling;

      while (node) {
        if (node.classList && node.classList.contains('shopify-section')) {
          var hasTopBar = node.querySelector('.maxi-cashback-bar, .announcement-bar');

          if (hasTopBar) {
            offset += getSectionHeight(node);
          }
        }

        node = node.previousElementSibling;
      }
    }

    document.documentElement.style.setProperty('--maxi-sticky-top-offset', offset + 'px');

    var cashbackSection = document.querySelector('.maxi-cashback-bar')
      ? document.querySelector('.maxi-cashback-bar').closest('.shopify-section')
      : null;

    document.documentElement.style.setProperty(
      '--maxi-cashback-height',
      getSectionHeight(cashbackSection) + 'px'
    );
  }

  function init() {
    updateStickyOffset();

    window.addEventListener('resize', updateStickyOffset);
    window.addEventListener('load', updateStickyOffset);

    if (window.ResizeObserver) {
      var cashbackBar = document.querySelector('.maxi-cashback-bar');

      if (cashbackBar) {
        new ResizeObserver(updateStickyOffset).observe(cashbackBar);
      }
    }

    if (window.MutationObserver) {
      new MutationObserver(updateStickyOffset).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
